export enum Types {
	ATUALIZAR_ATENDENTE = '@aac/ATUALIZAR_ATENDENTE',
	ATUALIZAR_ATENDENTE_SUCCESS = '@aac/ATUALIZAR_ATENDENTE_SUCCESS',
	ATUALIZAR_ATENDENTE_FAILURE = '@aac/ATUALIZAR_ATENDENTE_FAILURE',
	LIMPA_ATUALIZAR_ATENDENTE = '@aac/LIMPA_ATUALIZAR_ATENDENTE',
}

export interface AtualizaAtendente {
	status: number;
	resultado: ConsultaUsuarioPendente[] | null;
}

export interface ConsultaUsuarioPendente {
	codigoValidacao: string;
	id: string;
	posto: string;
	tipoEncaminhamento: string;
	dataEmissaoAtestado: string;
	usuarioCentral: string;
	tipoLiberacao: string;
	positivaInicio: string;
	positivaTermino: string;
	usuarioPosto: string;
	dataCentralEncerrado: string;
	encerrado: string;
	numeroRg: string;
	nome: string;
	nomePai: string;
	nomeMae: string;
	sexo: string;
	dataNascimento: string;
	dataNascimentoTs: string;
	dataExpedicaoRg: string;
	resultado: string;
	status: string;
	retorno: string;
	usuario: string;
	tipoAA: string;
	tipoDocApresentado: string;
	tipoDoc: string;
	nomeProcurador: string;
	nomeSocial: string;
	dc: string;
	docProcurador: string;
	cpf: string;
	dcCpf: string;
	exigenciaBaixaDesaparecido: boolean;
	exigenciaBO: boolean;
	exigenciaBODelegacia: string;
	exigenciaBONumero: string;
	exigenciaCertidaoCriminais: boolean;
	exigenciasCertidaoCriminais: string[];
	exigenciaCertidaoDistribuidor: boolean;
	exigenciasCertidaoDistribuidor: string[];
	exigenciaCertidaoObjeto: boolean;
	exigenciaCopiaApresentado: boolean;
	exigenciasDelegacia: string[];
	exigenciaEvadido: boolean;
	exigenciasIP: string[];
	exigenciaPreso: boolean;
	exigenciasInstauracao: string[];
	exigenciasObservacao: string[];
	exigenciasProcesso: string[];
	exigenciasVara: string[];
	naoPgtoDataCertidao: string;
	naoPgtoNumeroCertidao: string;
	positivaExecucao: string;
	positivasObservacao: string[];
	positivaRegime: string;
}

export interface RequestAtualizarAtendente {
	identifUsuario: string;
	numeroPosto: string;
}
